import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

export default class Tab extends React.Component {

    static propTypes = {
        currentTab: PropTypes.any,
        tabName: PropTypes.any,
        onClick: PropTypes.func,
        className: PropTypes.any
    };

    render() {
        return (
            <li
                className={classNames("nav-item", {active: this.props.tabName !== undefined && this.props.currentTab === this.props.tabName, disabled: this.props.disabled}, this.props.className)}
            >
                <a
                    href="#"
                    className={classNames("nav-link", {active: this.props.tabName !== undefined && this.props.currentTab === this.props.tabName, disabled: this.props.disabled})}
                    onClick={(e) => {
                        e && e.preventDefault();
                        if(this.props.onClick && !this.props.disabled) {
                            this.props.onClick(e, this.props.tabName);
                        }
                    }}
                >
                    {this.props.children}
                </a>
            </li>
        );
    }
}